/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-support-api-client";
import type { BulkUploadBcrFilesMutationRequest, BulkUploadBcrFilesMutationResponse } from "../models/BulkUploadBcrFiles";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { bulkUploadBcrFiles } from "../axios/bulkUploadBcrFiles";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const bulkUploadBcrFilesMutationKey = () => ["audit-support-api", { url: '/bcr-files/bulk-upload' }] as const

export type BulkUploadBcrFilesMutationKey = ReturnType<typeof bulkUploadBcrFilesMutationKey>

export function bulkUploadBcrFilesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BulkUploadBcrFilesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = bulkUploadBcrFilesMutationKey()
        return mutationOptions<BulkUploadBcrFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadBcrFilesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return bulkUploadBcrFiles(data, config)
          },
        })

}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload BCR files
 * {@link /bcr-files/bulk-upload}
 */
export function useBulkUploadBcrFiles<TContext>(options: 
{
  mutation?: UseMutationOptions<BulkUploadBcrFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadBcrFilesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BulkUploadBcrFilesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? bulkUploadBcrFilesMutationKey()

          const baseOptions = bulkUploadBcrFilesMutationOptions(config) as UseMutationOptions<BulkUploadBcrFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadBcrFilesMutationRequest}, TContext>
          

          return useMutation<BulkUploadBcrFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadBcrFilesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BulkUploadBcrFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadBcrFilesMutationRequest}, TContext>
      
}